<template>
  <!-- https://github.com/glennflanagan/vue-collapsible/blob/master/src/components/Collapsible.vue -->
  <div
    class="collapsible"
    :class="{
      'collapsible--no-color': noColor,
      'collapsible--no-margin': noMargin,
      'collapsible--border': bordered,
    }"
  >
    <div
      :class="{
        collapsible__trigger: true,
        'collapsible__trigger--open': !transitioning && open,
        'collapsible__trigger--closed': !transitioning && !open,
        'collapsible__trigger--transitioning': transitioning,
      }"
      @click.prevent="handleClick"
    >
      <div class="collapsible__title">
        <Icon v-if="icon" class="collapsible__title__icon">{{ Icons[icon] }}</Icon>
        <p>{{ title }}</p>
      </div>
      <div class="collapsible__arrow__wrapper">
        <Icon
          class="collapsible__arrow"
          :class="{
            collapsible__trigger: true,
            'collapsible__arrow--open': open,
            'collapsible__arrow--closed': !open,
          }"
        >
          {{ Icons['arrowDownThin'] }}
        </Icon>
      </div>
    </div>

    <div
      :class="{
        collapsible__content: true,
        'collapsible__content--open': !transitioning && open,
        'collapsible__content--closed': !transitioning && !open,
        'collapsible__content--transitioning': transitioning,
      }"
      :style="{
        height,
        transitionProperty: 'height',
        transitionDuration,
        transitionTimingFunction,
        transitionDelay,
      }"
      @transitionend="handleEnd"
    >
      <div ref="inner" class="collapsible__contentInner">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icon.vue';
import * as Icons from '@/assets/icons';

export default {

  name: 'Collapsible',

  components: {
    Icon,
  },

  props: {
    title: {
      type: String,
      default: 'Title',
    },
    transitionDuration: {
      type: String,
      default: '400ms',
    },
    transitionTimingFunction: {
      type: String,
      default: 'ease',
    },
    transitionDelay: {
      type: String,
      default: '0s',
    },
    isOpen: {
      default: true,
      type: Boolean,
    },
    onCollapse: {
      default: () => {},
      type: Function,
    },
    icon: {
      type: String,
      default: '',
    },
    noColor: {
      type: Boolean,
    },
    noMargin: {
      type: Boolean,
    },
    bordered: {
      type: Boolean,
    },
  },

  data() {
    return {
      Icons,
      open: this.isOpen,
      height: this.isOpen ? 'auto' : '0px',
      closeOnNextTick: false,
      transitioning: false,
    };
  },

  watch: {
    open(newVal, oldVal) {
      this.transitioning = true;
      this.height = `${this.$refs.inner.scrollHeight}px`;
      this.emitAnimationEnd();
      if (oldVal === true) {
        this.closeOnNextTick = true;
      }
    },
    isOpen(newVal) {
      this.open = newVal;
    },
  },
  updated() {
    this.$nextTick(() => {
      window.setTimeout(() => {
        if (this.closeOnNextTick) {
          this.height = '0px';
          this.closeOnNextTick = false;
        }
      });
    });
  },

  methods: {
    handleClick() {
      this.onCollapse(!this.isOpen);
      this.open = !this.open;
    },
    handleEnd() {
      if (this.height !== '0px') {
        this.height = 'auto';
      }
      this.transitioning = false;
    },
    emitAnimationEnd() {
      this.$emit('animationEnd', this.transitionDuration);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.collapsible {
  cursor: pointer;
  color: white;

  &--border {
    border-top: 1px solid #F0F0F0;
  }

  &--no-color {

    & .collapsible__contentInner {
      background: none;
      color: $color-shizen-blue;
    }

    & .collapsible__trigger {
      background: none;
      color: $color-shizen-blue;
    }

    & .collapsible__title > p {
      color: $color-shizen-blue;
    }
  }

  &--no-margin {

    & .collapsible__title {
      padding-left: 0;
    }

    & .collapsible__arrow__wrapper {
      padding-right: 0;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    padding: 0 5px 0 20px;
    margin: 1em 0;

    & > p {
      color: white;
    }

    &__icon {
      min-width: 1.1rem;
      max-width: 1.1rem;
      margin-right: 0.75em;
    }
  }

  &__arrow {
    transition: 0.3s all;

    &__wrapper {
      padding-right: 1em;
    }

    &--open {
      transform: rotate(-180deg);
    }
  }

  &__contentInner {
    height: auto;
    background: #010d2c;
  }

  &__content {
    overflow: hidden;
  }

  &__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $color-shizen-blue;
  }
}
</style>
